import { render, staticRenderFns } from "./Do.vue?vue&type=template&id=1f9bfffa&scoped=true&"
import script from "./Do.vue?vue&type=script&lang=js&"
export * from "./Do.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9bfffa",
  null
  
)

export default component.exports